import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

import { getApiBase } from "@/utils/apiBase";
const API = getApiBase();
const SiteContentContext = createContext({ content: null, refresh: () => {} });

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);

  const refresh = async () => {
    try {
      const r = await axios.get(`${API}/site-content`);
      setContent(r.data);
    } catch {
      setContent(null);
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <SiteContentContext.Provider value={{ content, refresh }}>
      {children}
    </SiteContentContext.Provider>
  );
};

export const useSiteContent = () => useContext(SiteContentContext);
